import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import Checkbox from "components/ui/checkbox/Checkbox";
import "./tooltip.scss";
export interface IToolTip {
  readonly contentHeading?:string
  readonly content?: string;
  readonly checkboxLabel?: string;
  readonly position?: "up" | "down" | "left" | "right";
  readonly isIconRequired?: boolean;
  readonly isCheckBoxRequired?: boolean;
  readonly handleClick?: () => void;
}

function ToolTip({
  contentHeading,
  content,
  checkboxLabel,
  position,
  isIconRequired,
  isCheckBoxRequired,
  handleClick,
}: IToolTip) {
  return (
    <div className="tooltip">
        <div className={position} data-testid="tooltip">
          <div className="tooltip--primary">
            {isIconRequired && (
              <button
                type="button"
                onClick={() => {
                  handleClick?.();
                }}
                className="tooltip--primary__icon"
                title="icon"
                aria-label="Close tooltip"
              >
                <FontAwesomeIcon icon={regular("xmark")} />
              </button>
            )}
            <span className="tooltip--primary__info">{contentHeading && <b>{`${contentHeading} :`}</b>} {content}</span>
            {isCheckBoxRequired && (
              <span>
                <Checkbox
                  label={checkboxLabel}
                  onChange={() => handleClick?.()}
                />
              </span>
            )}
          </div>
        </div>
    </div>
  );
}

export default ToolTip;
